import AccountingWrapper from "../../../../Components/v2/Accounting/AccountingWrapper";
import AccountingPageHeader from "../../../../Components/v2/Accounting/AccountingPageHeader";
import PeriodClosePanel from "../../../../Components/v2/Accounting/PeriodClosePanel";
import { useAuthState } from "../../../../Context";

const PeriodCloseV2 = () => {
  const { user } = useAuthState();

  return (
    <AccountingWrapper>
      <main className="lg:col-span-9 min-w-0">
        <AccountingPageHeader title="accounting.period.label" />

        <div className="px-4 py-5 sm:px-6 lg:px-8">
          <PeriodClosePanel
            businessID={user?.mainBusiness?.id}
            business={user?.mainBusiness}
          />
        </div>
      </main>
    </AccountingWrapper>
  );
};

export default PeriodCloseV2;
